// Marketing entrypoint. Loads the Tailwind stylesheet and the minimal
// scroll-reveal observer. The entrypoint is referenced from
// app/views/layouts/marketing.html.erb via vite_typescript_tag "marketing".
import './marketing.css'

function initReveals(): void {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll<HTMLElement>('[data-reveal]').forEach((el) => {
      el.classList.add('srx-in')
    })
    return
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('srx-in')
          io.unobserve(entry.target)
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
  )

  document.querySelectorAll<HTMLElement>('[data-reveal]').forEach((el) => io.observe(el))
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReveals)
} else {
  initReveals()
}
